import React, { FC } from 'react';

import { Typography } from '../typography';
import Styled from './styles';

interface IInputProps {
	title: string;
	isActive: boolean;
	totalTabs: number;
	isDescr?: boolean;
	counter?: number;
	callback(title: string): void;
}

const Tab: FC<IInputProps> = ({
	title,
	isActive,
	totalTabs,
	isDescr,
	counter,
	callback,
}) => {
	return (
		<Styled.Tab
			isActive={isActive}
			totalTabs={totalTabs}
			onClick={() => callback(title)}
		>
			<Styled.Descr
				text={title}
				size="normal"
				type="bold"
				color={isActive ? 'black' : 'btnTextGrey'}
			/>
			{isDescr && (
				<Styled.Counter>
					<Typography
						text={
							counter && counter < 10
								? counter?.toString()
								: counter
								? '9+'
								: '0'
						}
						size="tiny"
						type="bold"
						color={'black'}
					/>
				</Styled.Counter>
			)}

			{isActive && <Styled.Mark />}
		</Styled.Tab>
	);
};

export default Tab;
